import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
    GET_FUNCTIES: (
        pageSizeCount,
        pageNumber,
        searchValue
    ) => ({
        url: `functie?pageSize=${pageSizeCount}&page=${pageNumber}&search=${searchValue}`,
        method: "get",
    }),

    SAVE_FUNCTIE: {
        url: "functie/save",
        method: "post",
    },

    UPDATE_FUNCTIE: {
        url: "functie/update",
        method: "put",
    },
};

export const useFuncties = (
    pageSizeCount,
    pageNumber,
    searchValue
) =>
    useApiFetcherSWR(
        API_ENDPOINT.GET_FUNCTIES(
            pageSizeCount,
            pageNumber,
            searchValue
        )
    );

export const useSaveFunctie = () =>
    useApiFetcherSWR(API_ENDPOINT.SAVE_FUNCTIE);

export const useUpdateFunctie = () =>
    useApiFetcherSWR(API_ENDPOINT.UPDATE_FUNCTIE);